import { useState, useEffect } from 'react';
import { fetchSession } from '../services/AppSessionServices';
import { ITickets } from '../pages/customerdetail/models/customerDataModels';

interface UseFetchSessionProps {
    storeId: string;
    sessionId: string;
    clientToken: string;
    smsCode: string;
    tableRef: string;
}

export const useFetchSession = ({
    storeId,
    sessionId,
    clientToken,
    smsCode,
    tableRef,
}: UseFetchSessionProps): {
    sessionResponse: ITickets | null;
    sessionError: boolean;
    loading: boolean;
} => {
    const [sessionResponse, setSessionResponse] = useState<ITickets | null>(null);
    const [sessionError, setSessionError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response: ITickets = await fetchSession(storeId, sessionId, clientToken, smsCode, tableRef);
                if (!response.error) {
                    setSessionResponse(response);
                    setSessionError(false);
                } else {
                    setSessionError(true);
                }
            } catch (err) {
                setSessionError(true);
            } finally {
                setLoading(false);
            }
        };

        if (storeId && sessionId && clientToken && smsCode && tableRef) {
            fetchData();
        } else {
            setLoading(false);
        }
    }, [storeId, sessionId, clientToken, smsCode, tableRef]);

    return { sessionResponse, sessionError, loading };
};
